/* AMPEL theme behaviour */
(function () {
  'use strict';

  /* 1. Sticky header solidifies on scroll */
  function headerSolidify() {
    var wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;
    var onScroll = function () {
      wrapper.classList.toggle('amp-solid', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 2. Reveal on scroll */
  function reveals() {
    var nodes = document.querySelectorAll('.amp-reveal');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var d = parseInt(en.target.getAttribute('data-delay') || '0', 10);
          setTimeout(function () { en.target.classList.add('is-in'); }, d);
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    nodes.forEach(function (n) { io.observe(n); });
    /* safety: never leave content hidden */
    setTimeout(function () {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
    }, 2800);
  }

  /* 3. AJAX add-to-cart for AMPEL collection cards */
  function updateCartBubble() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var icon = document.querySelector('#cart-icon-bubble');
        if (!icon) return;
        var bubble = icon.querySelector('.cart-count-bubble');
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          icon.appendChild(bubble);
        }
        bubble.innerHTML =
          '<span aria-hidden="true">' + (cart.item_count < 100 ? cart.item_count : '99+') + '</span>' +
          '<span class="visually-hidden">' + cart.item_count + '</span>';
      })
      .catch(function () {});
  }

  function ajaxAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-amp-add]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-amp-add-btn]');
      var lbl = form.querySelector('[data-amp-lbl]');
      var prev = lbl ? lbl.textContent : '';
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          updateCartBubble();
          if (lbl) lbl.textContent = form.getAttribute('data-amp-added-text') || 'Added to cart ✓';
          if (btn) btn.classList.add('is-added');
          setTimeout(function () {
            if (lbl) lbl.textContent = prev;
            if (btn) btn.classList.remove('is-added');
          }, 1400);
        })
        .catch(function () {
          /* graceful fallback: normal submit to /cart/add */
          form.removeAttribute('data-amp-add');
          form.submit();
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      headerSolidify(); reveals(); ajaxAdd();
    });
  } else {
    headerSolidify(); reveals(); ajaxAdd();
  }
  document.addEventListener('shopify:section:load', reveals);
})();

/* ---------- Offer countdown (hero) ---------- */
(function(){
  var el=document.querySelector('[data-amp-count]');
  if(!el) return;
  var end=new Date(el.getAttribute('data-end'));
  if(isNaN(end)) return;
  var d=el.querySelector('[data-amp-d]'),h=el.querySelector('[data-amp-h]'),m=el.querySelector('[data-amp-m]'),s=el.querySelector('[data-amp-s]');
  function tick(){
    var diff=end-new Date();
    if(diff<=0){el.hidden=true;clearInterval(t);return;}
    el.hidden=false;
    var sec=Math.floor(diff/1000);
    d.textContent=Math.floor(sec/86400);
    h.textContent=Math.floor(sec%86400/3600);
    m.textContent=Math.floor(sec%3600/60);
    s.textContent=sec%60;
  }
  var t=setInterval(tick,1000); tick();
})();

/* ---------- Sticky add-to-cart bar (product pages, mobile-first) ---------- */
(function(){
  var submit=document.querySelector('.product-form__submit');
  var info=document.querySelector('product-info');
  if(!submit||!info) return;
  var title=(document.querySelector('.product__title')||{}).textContent||'';
  var priceEl=document.querySelector('.product .price__container .price-item--sale, .product .price__container .price-item--regular');
  var price=priceEl?priceEl.textContent.trim():'';
  var bar=document.createElement('div');
  bar.className='amp-sticky-atc';
  bar.innerHTML='<div class="amp-sticky-atc__meta"><span class="amp-sticky-atc__title"></span><span class="amp-sticky-atc__price"></span></div><button type="button" class="amp-sticky-atc__btn">Add to cart</button>';
  bar.querySelector('.amp-sticky-atc__title').textContent=title.trim();
  bar.querySelector('.amp-sticky-atc__price').textContent=price;
  document.body.appendChild(bar);
  bar.querySelector('.amp-sticky-atc__btn').addEventListener('click',function(){
    submit.click();
    bar.classList.add('amp-sticky-atc--busy');
    setTimeout(function(){bar.classList.remove('amp-sticky-atc--busy');},1200);
  });
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){
      bar.classList.toggle('amp-sticky-atc--on',!en[0].isIntersecting);
    },{rootMargin:'-80px 0px 0px 0px'});
    io.observe(submit);
  } else {
    bar.classList.add('amp-sticky-atc--on');
  }
})();
